import { default as BaseBreadcrumbs } from '@/components/Breadcrumbs';
import breadcrumbs from '@/modules/admin/breadcrumbs';

const Breadcrumbs = () => <BaseBreadcrumbs breadcrumbs={breadcrumbs} />;

export default Breadcrumbs;
